import { writable } from 'svelte/store'
import { database } from './indexeddb'

const STORE_NAME = 'recently_sent'

export function createRecentlySentStore () {
  const { subscribe, set } = writable([])

  async function load () {
    const items = await database.getAll(STORE_NAME)
    items.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    set(items)
    return items
  }

  return {
    subscribe,
    load,

    async add (item) {
      const tx = database.transaction(STORE_NAME, 'readwrite')
      await tx.store.add(item)
      
      const items = await tx.store.getAll()
      items.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      
      // Keep only last 3
      if (items.length > 3) {
        const toDelete = items.slice(3)
        for (const oldItem of toDelete) {
          await tx.store.delete(oldItem.id)
        }
      }
      
      await tx.done
      await load()
    },

    async clearAll () {
      await database.clear(STORE_NAME)
      await load()
    }
  }
}
